import http from "../http-common";
import { sanitizeGateReturnUrl } from "../utils/gateReturnUrl";
import { applyAuthTokensAndRedirect, prepareGateLoginSession } from "../utils/sessionUtils";

export async function performGateLogin(
  code: string,
  gateInstance: string | null,
  gateReturnUrl: string | null,
  hintEmail: string | null
): Promise<void> {
  const priorRefreshToken = localStorage.getItem("refreshToken") ?? "";
  prepareGateLoginSession(hintEmail);

  const body: { code: string; gateInstance?: string; priorRefreshToken?: string } = { code };
  if (gateInstance) {
    body.gateInstance = gateInstance;
  }
  if (priorRefreshToken) {
    body.priorRefreshToken = priorRefreshToken;
  }

  const response = await http.post("/auth/gate-login", body);

  const safeReturn = sanitizeGateReturnUrl(gateReturnUrl);
  if (safeReturn) {
    localStorage.setItem("gateReturnUrl", safeReturn);
  } else {
    localStorage.removeItem("gateReturnUrl");
  }

  await applyAuthTokensAndRedirect(response);
}
